<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <h3 class="text-gray-600 m-0"><i class="fas fa-user me-2"></i>Add New Broker</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active text-primary">
                                <i class="fas fa-building" aria-hidden="true"></i>Broker Details
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <form *ngIf="addBrokerFormGroup" (submit)="addBroker()" [formGroup]="addBrokerFormGroup">
                <error-message [errors]="errors"></error-message>
                <h4 class="mt-5 text-primary">Broker Details</h4>
                <div class="row mt-3">
                    <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="control-label text-primary">
                                Name
                            </label>
                            <input type="text" class="form-control" formControlName="name" />
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="control-label text-primary">
                                Company
                            </label>
                            <select name="companyId" class="form-select" formControlName="companyId">
                                <option *ngFor="let company of companyList" [value]="company.id">{{company.tradingName || company.legalName}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <footer class="panel-footer mt-3">
                    <div class="row">
                        <div class="col-12 text-end">
                            <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()">Back</button>
                            <button class="btn btn-success ms-2" type="submit" [disabled]="!addBrokerFormGroup.valid">Save</button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </div>
</section>
